import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/offer';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="faq" data-id="element-26" data-mp="1gdgzpcni0i27">
      <div className="mx-auto max-w-3xl px-5" data-id="element-27" data-mp="2e0g1u2wymi7h">
        <SectionHeading eyebrow="Dudas frecuentes" title={<span id="faq" data-id="element-29" data-mp="291d2mz3nv67f">Antes de entrar</span>} data-id="element-28" data-mp="2dz4y233ilagd" />

        <div className="mt-10 space-y-3" data-id="element-30" data-mp="292o4uuhgk5wf">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-ink-800" data-id="element-31" data-mp="1z3fgqi99xlhz" data-mpi={index}>
                <h3 data-id="element-32" data-mp="soeiu70out8r">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-sm font-bold text-white transition-colors hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-cyan" data-id="element-33" data-mp="skqqhb6zccvm">
                    {faq.question}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand-cyan transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-34" data-mp="kha3aee10kq6" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-35" data-mp="3swtqavo3t6ws">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-36" data-mp="1q93jo530l5k">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-white/60" data-id="element-37" data-mp="1uixn7ab8fn9j">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}